import { getApiUrl } from "./tcApiUrl";
export function getUserPlansByIdURL() {
  const getuserplanbyidurl = `${getApiUrl("tc/getUserPlansById")}`;
  return getuserplanbyidurl;
}

export const getUserPlansByIdURLValue = () => {
  return getUserPlansByIdURL();
};
